import React, {useState, useRef} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'block',
  },
  search: {
    marginTop:'-2px',
    height:'29px',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.35),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.55),
    },
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    marginBottom:'3px',
    transition: theme.transitions.create('width'),
    width: '9ch',
      '&:focus': {
        width: '13ch',
      }
  },
}));

export default function SearchAppBar(props) {
  const [value, setValue]=useState('');
  const classes = useStyles();

  let first_time=useRef(true);


  return (
      <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon style={props.style}/>
        </div>
        <InputBase
          placeholder="Search…"
          onKeyDown={(e)=>{if(e.keyCode==13){props.onChange(e.target.value);}}}
          value={(value=='' && props.initial_value!=undefined && first_time.current==true)?props.initial_value:value}
          onChange={(e)=>{first_time.current=false; setValue(e.target.value)}}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{ 'aria-label': 'search' }}
        />
      </div>
  );
}
